import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { questionValidation } from '../../functions/Validation';
import QuestionHelp from '../question/QuestionHelp';
import ValidationMessage from '../question/ValidationMessage';
import { tracking } from '../../functions/Tracking';
import { Action } from '../../enums/TrackingActionType';
import { useOutsideClick } from '../../functions/OutsideClick';
import './customDropdown.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import { IsWebReference } from '../../functions/Configuration';

export default function CustomDropdown(props: any) {

    const [question, setQuestion] = useState(props.question);
    const [dropdownValue, setDropdownValue] = useState(question.answer);
    const [filteredAnswerList, setFilteredAnswerList] = useState(props.question.answerList);
    const [textValue, setTextValue] = useState(question.answer);
    const [secondsFocused, setSecondsFocused] = useState(0);
    const [showOptions, setShowOptions] = useState(false);
    const [showBlankOption, setShowBlankOption] = useState(true);
    const [inputLoaded, setInputLoaded] = useState(false);
    const [inputInteraction, setinputInteration] = useState(false);
    const timerId = useRef<number>(0);
    let webReference = localStorage.getItem('webReference') || "";
    let companyStatus = localStorage.getItem('status') || "";

    var inputClasses = classNames(
        {
            'dropdown-input': true,
            'validation-fail': question.validationFail
        }
    );

    var labelClasses = classNames(
        {
            'validation-fail-lbl': question.validationFail
        }
    );

    const validateAnswer = () => {
        stopTimer();
        if (inputLoaded) {
            if (IsWebReference("TL") && companyStatus === "limited" && (question.questionSetQuestion.text.toLowerCase() === "how many directors carry out manual work?" ||
                question.questionSetQuestion.text.toLowerCase() === "how many directors are there that carry out clerical work only?") && question.answer !== "" ||
                IsWebReference("RPO") && question.repeatable) {
                // don't do standard validation for related questions as it overrides the other validation 
            } else {
                tracking(Action.SAVE_QUESTIONS, question.questionSetQuestion.questionID);
                question.validationFail = !questionValidation(question);

                setQuestion(question);
            }
        }
    };

    const handleClickOutside = () => {
        var searchBox = document.getElementById('search_' + question.questionSetQuestion.questionID);
        
        // check for focus
        var isFocused = (document.activeElement === searchBox);
        // DEV NOTE: The inputInteraction check is to stop handleClickOutside triggered from another dropdown firing a validation check on this dropdown
        // before it's been interacted with. This is to prevent displaying a validation failure on a question the user hasn't got to yet 
        if (!isFocused && inputInteraction) {
            setShowOptions(false);
            setShowBlankOption(true);
            setFilteredAnswerList(props.question.answerList);
            validateAnswer();
        }
    };

    const ref = useOutsideClick(handleClickOutside);

    useEffect(() => {
        setQuestion(props.question);
        if (props.question.answer) {
            setDropdownValue(props.question.answer);
            let dropDownText = "";
            if (props.question.answerList.find((x: { value: any; }) => x.value === props.question.answer) !== undefined) {
                dropDownText = props.question.answerList.find((x: { value: any; }) => x.value === props.question.answer).text;
            }
            setTextValue(dropDownText);
        }

        document.addEventListener("updateAnswer", function (e) {
            let eventDetails: any = e;
            if (eventDetails.detail.questionID === question.questionSetQuestion.questionID) {
                setDropdownValue(eventDetails.detail.answer);
                let dropDownText = props.question.answerList.find((x: { value: any; }) => x.value === eventDetails.detail.answer).text;
                setTextValue(dropDownText);
            }
        });
        setInputLoaded(true);
    }, []);

    useEffect(() => {
        if (secondsFocused === 60) {
            //alert("Too much time has passed");
            //alert(question.questionSetQuestion.text);
        }
    }, [secondsFocused]);

    useEffect(() => {
        if (inputLoaded) {
            question.answer = dropdownValue;
            setQuestion(question);
            props.setIndividualCustomerDetails(question);
            props.showConditionQuestions(question.questionSetQuestion.questionID, dropdownValue);
            props.enableQuestions(question.questionSetQuestion.questionID);
            props.resetRelatedQuestionsValidationOnAnswerChange(question.questionSetQuestion.questionID, dropdownValue);
            if (props.questionIdPosition !== undefined) {
                if ((props.questionIdPosition.split('|').length - 1) === 1) {
                    let questionIdPositionItems = props.questionIdPosition.split('|');
                    let parentID = questionIdPositionItems[0].split('-')[0];
                    let childID = questionIdPositionItems[1].split('-')[0];
                    let childIndex = questionIdPositionItems[1].split('-')[1];

                    props.showConditionalChildren(parentID, dropdownValue, childID, childIndex);
                }

                if ((props.questionIdPosition.split('|').length - 1) === 2) {
                    let questionIdPositionItems = props.questionIdPosition.split('|');
                    let parentID = questionIdPositionItems[0].split('-')[0];
                    let parentChildID = questionIdPositionItems[1].split('-')[0];
                    let parentChildIndex = questionIdPositionItems[1].split('-')[1];
                    let childID = questionIdPositionItems[2].split('-')[0];
                    let childIndex = questionIdPositionItems[2].split('-')[1];

                    props.showConditionalChildren(parentID, dropdownValue, parentChildID, parentChildIndex, childID, childIndex);
                }
            }
        }
    }, [dropdownValue]);

    const startTimer = () => {
        timerId.current = window.setInterval(() => {
            setSecondsFocused(prev => prev + 1);
        }, 1000);
    };

    const stopTimer = () => {
        window.clearInterval(timerId.current);
        setSecondsFocused(0);
    };

    const selectOption = (value: string, text: string) => {
        setDropdownValue(value);
        setTextValue(text);
        setShowOptions(false);
        tracking(Action.SAVE_QUESTIONS, question.questionSetQuestion.questionID);
        if (value !== "" && question.questionSetQuestion.mandatory) {
            question.validationFail = false;
            setQuestion(question);
        }

        if (props.isRepeatable) {
            props.updateRepeatableAnswer(value);
        }

        tracking(Action.SAVE_QUESTIONS, question.questionSetQuestion.questionID);
        stopTimer();
    }

    const toggleShowOptions = () => {
        var searchBox = document.getElementById('search_' + question.questionSetQuestion.questionID);
        setinputInteration(true);
        // check for focus
        var isFocused = (document.activeElement === searchBox);

        if (!isFocused) {
            setShowOptions(!showOptions);
            if (showOptions) {
                validateAnswer();
            }
        } else {
            question.validationFail = false;
            setQuestion(question);
        }
        setShowBlankOption(true);
        setFilteredAnswerList(props.question.answerList);
    }

    const iconToggleShowOptions = (e: any) => {
        e.stopPropagation();
        toggleShowOptions();
    };

    const searchAnswerList = (e: React.ChangeEvent<HTMLInputElement>) => {
        let searchTerm = e.target.value;

        if (searchTerm !== "") {
            setShowBlankOption(false);
            document.getElementById('search-results')?.scroll({ top: 0, behavior: 'smooth' });
            setFilteredAnswerList(props.question.answerList.filter((x: { text: string; }) => x.text.toLowerCase().includes(searchTerm.toLowerCase())));
        } else {
            setShowBlankOption(true);
            setFilteredAnswerList(props.question.answerList);
        }
    }

    return (
        <>
            <div className="question">
                <label className={labelClasses} htmlFor={"valen_" + question.questionSetQuestion.questionID}>{question.questionSetQuestion.text}</label>
                <br />
                <div className="dropdown-container">
                    <div className="dropdown-inner">
                        <div
                            id={"valen_" + question.questionSetQuestion.questionID}
                            className={inputClasses}
                            onFocus={() => startTimer()}
                            onClick={() => toggleShowOptions()}
                            ref={ref}
                        ><span className="dropdown-input-text">{textValue}</span>
                            {!showOptions && <span className="dropdown-icon" onClick={iconToggleShowOptions}><FontAwesomeIcon icon={faChevronDown} onClick={(e) => toggleShowOptions()} /></span>}
                            {showOptions && <span className="dropdown-icon" onClick={iconToggleShowOptions}><FontAwesomeIcon icon={faChevronUp} onClick={(e) => toggleShowOptions()} /></span>}
                        </div>
                        {question.questionSetQuestion.helpText !== null && question.questionSetQuestion.helpText !== "" &&
                            <QuestionHelp helpText={question.questionSetQuestion.helpText} questionID={question.questionSetQuestion.questionID} />
                        }
                        <br />
                        {showOptions &&
                            <div className="custom-dropdown-container">
                                <input type="text" className="answerList-search" id={"search_" + question.questionSetQuestion.questionID} placeholder="Search" onClick={(e) => toggleShowOptions()} onChange={(e) => searchAnswerList(e)} />
                                <div className="custom-dropdown">
                                    {showBlankOption === true &&
                                        <div className="blank-dropdown-row dropdown-row" key={"blank_" + 0} onClick={() => selectOption("", "")}>{""}</div>
                                    }
                                    {filteredAnswerList.map((item: { value: string; text: string }, index: string) => (
                                        <div className="dropdown-row" key={item.value + "_" + index} onClick={() => selectOption(item.value, item.text)}>{item.text}</div>
                                    ))}
                                </div>
                            </div>
                        }
                    </div>
                </div>
                {question.validationFail && (!props.isRepeatable || question.answer === "") &&
                    <ValidationMessage question={question} overrideMessage="Please select an option" />}
            </div>
        </>

    );
};